 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chat":"chat","gf":"gf","HomeNew.vue":"HomeNew.vue","admin":"admin","aliBey":"aliBey","habit~nutrition":"habit~nutrition","nutrition":"nutrition","dashboard":"dashboard","workouts":"workouts","user":"user","einmalig":"einmalig","habit":"habit","shop":"shop","social":"social","deviceManagement":"deviceManagement","event":"event","friends":"friends","payment":"payment","redirection":"redirection"}[chunkId]||chunkId) + "." + {"chat":"ebf676bc","chunk-0070e25c":"54706c3e","chunk-05cfd0d3":"93f1bf65","chunk-0736488d":"18660c98","chunk-157c2bc2":"b116d296","gf":"1ed9d44b","chunk-1e90651e":"6022e378","chunk-217be9fa":"4eed72a2","HomeNew.vue":"d6cd1d41","admin":"b4de74b0","aliBey":"0979ddf4","chunk-7cd639cb":"e7d759f8","chunk-24f244bc":"c5a53b01","chunk-2c739c26":"573be649","habit~nutrition":"83b5cd08","nutrition":"4315c4db","chunk-4ff017dc":"b2dd42f3","chunk-57bafd5c":"03ed6f4c","chunk-0a29cabe":"b78c16e7","chunk-8a400556":"e18da5c4","chunk-502b709f":"7586580a","chunk-932f4228":"aa63bd05","chunk-b067410a":"d2c87fd7","chunk-d66babfe":"19228b38","dashboard":"a5ae73c4","workouts":"23c3766b","chunk-8987cf4e":"06e59e06","chunk-26aae596":"0a347adc","user":"ad6e9fba","chunk-ef2249dc":"c50b72f9","einmalig":"01c45a15","habit":"2b6bba5b","chunk-855a8646":"0cfbf278","chunk-37f5ccf1":"ca8877c6","chunk-022953ab":"95faee5e","chunk-2d0ae56b":"24eba63a","chunk-2d0bff72":"82eace44","chunk-2d0c8467":"63d7035b","chunk-2d0dda10":"3e807648","chunk-2d216257":"58872a85","chunk-2d0aa74a":"a2adcfa3","chunk-2d225092":"a8d6cd33","chunk-351eb10e":"90638a7c","chunk-4ed899c1":"f29a2201","chunk-4f70ea14":"7be809d1","chunk-5f2f7cde":"d64ef171","shop":"8d833a8f","chunk-6e83591c":"22ec3898","chunk-28353157":"f8784253","chunk-6e8eb25d":"c7fc36d6","chunk-6f66eaa9":"fb90b85b","chunk-4e476ad8":"7fdbeb8e","chunk-b6599cc6":"1d9bd98e","chunk-c7994324":"84ac4b5d","social":"8a20d89e","deviceManagement":"18e1f035","event":"c5a86e2d","friends":"5fd22943","payment":"28e16db5","redirection":"8d848703","chunk-2d21a041":"01e21151","chunk-2d216214":"1cff4ebd","chunk-98d9929e":"3f2e9bfa"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chat":1,"chunk-0070e25c":1,"chunk-05cfd0d3":1,"chunk-0736488d":1,"gf":1,"chunk-1e90651e":1,"chunk-217be9fa":1,"HomeNew.vue":1,"admin":1,"aliBey":1,"chunk-7cd639cb":1,"chunk-24f244bc":1,"chunk-2c739c26":1,"habit~nutrition":1,"nutrition":1,"chunk-4ff017dc":1,"chunk-57bafd5c":1,"chunk-0a29cabe":1,"chunk-8a400556":1,"chunk-502b709f":1,"chunk-932f4228":1,"chunk-b067410a":1,"chunk-d66babfe":1,"dashboard":1,"workouts":1,"chunk-8987cf4e":1,"chunk-26aae596":1,"user":1,"chunk-ef2249dc":1,"einmalig":1,"habit":1,"chunk-855a8646":1,"chunk-37f5ccf1":1,"chunk-022953ab":1,"chunk-351eb10e":1,"chunk-4ed899c1":1,"chunk-4f70ea14":1,"shop":1,"chunk-28353157":1,"chunk-6e8eb25d":1,"chunk-6f66eaa9":1,"chunk-4e476ad8":1,"chunk-b6599cc6":1,"chunk-c7994324":1,"social":1,"deviceManagement":1,"event":1,"friends":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chat":"chat","gf":"gf","HomeNew.vue":"HomeNew.vue","admin":"admin","aliBey":"aliBey","habit~nutrition":"habit~nutrition","nutrition":"nutrition","dashboard":"dashboard","workouts":"workouts","user":"user","einmalig":"einmalig","habit":"habit","shop":"shop","social":"social","deviceManagement":"deviceManagement","event":"event","friends":"friends","payment":"payment","redirection":"redirection"}[chunkId]||chunkId) + "." + {"chat":"3f3921c3","chunk-0070e25c":"b7673d55","chunk-05cfd0d3":"9409075c","chunk-0736488d":"51a36163","chunk-157c2bc2":"31d6cfe0","gf":"c9855acb","chunk-1e90651e":"f95702ee","chunk-217be9fa":"fd8c3217","HomeNew.vue":"8fc725f6","admin":"307e0c62","aliBey":"26b8b2ea","chunk-7cd639cb":"df7dfdc2","chunk-24f244bc":"dee56bdd","chunk-2c739c26":"e8933506","habit~nutrition":"551557c5","nutrition":"7d5e1320","chunk-4ff017dc":"3aae6cf4","chunk-57bafd5c":"f7b5de0c","chunk-0a29cabe":"aa93e336","chunk-8a400556":"cc1ed9bf","chunk-502b709f":"58bd2dfb","chunk-932f4228":"6742de6e","chunk-b067410a":"b4b6f499","chunk-d66babfe":"0259284e","dashboard":"2ad476a3","workouts":"2392979a","chunk-8987cf4e":"f6612f63","chunk-26aae596":"1e6b9b9a","user":"dddbd98d","chunk-ef2249dc":"38cdad1c","einmalig":"fa492b35","habit":"346ce143","chunk-855a8646":"df716a94","chunk-37f5ccf1":"fb6b55c2","chunk-022953ab":"fd16e638","chunk-2d0ae56b":"31d6cfe0","chunk-2d0bff72":"31d6cfe0","chunk-2d0c8467":"31d6cfe0","chunk-2d0dda10":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-2d0aa74a":"31d6cfe0","chunk-2d225092":"31d6cfe0","chunk-351eb10e":"8b18ed18","chunk-4ed899c1":"e9b57efc","chunk-4f70ea14":"e234d813","chunk-5f2f7cde":"31d6cfe0","shop":"1674ba39","chunk-6e83591c":"31d6cfe0","chunk-28353157":"aa93e336","chunk-6e8eb25d":"62b6bdb5","chunk-6f66eaa9":"840f11ef","chunk-4e476ad8":"66e421c2","chunk-b6599cc6":"b71a634a","chunk-c7994324":"fbaae4d2","social":"38002047","deviceManagement":"a40c19d5","event":"d8b22b17","friends":"52064fe5","payment":"31d6cfe0","redirection":"31d6cfe0","chunk-2d21a041":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-98d9929e":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
